import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flex"];
import { Logo } from 'foundations-components/transitional/components/Logo';
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeLogo = _ref => {
  let {
      flex = '0 0 auto'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    flex: flex,
    children: /*#__PURE__*/_jsx(Logo, {
      name: "breeze-symbol-gradient"
    })
  }));
};